export default function PHP_idate() {
  return (
    <div>
      <h1>PHP_idate</h1>
    </div>
  );
}
